import axiosInstance from "./axios";
import { ResponseType } from "@/types/CommonTypes";
import {
  NewsItem,
  NewsItemPayload,
  NewsFeed,
  NewsListFilters,
} from "@/types/NewsTypes";

const BASE = "/news";

export const newsApi = {
  /** User-facing: dashboard cards, post-login pop-ups, blocking notices. */
  getFeed: async (lang?: string): Promise<ResponseType<NewsFeed>> => {
    const qs = lang ? `?lang=${encodeURIComponent(lang)}` : "";
    const response = await axiosInstance.get(`${BASE}/feed${qs}`);
    return response.data;
  },

  /** User-facing: bump impression counter (called when a popup is shown). */
  recordView: async (newsId: number): Promise<ResponseType<{ view_count: number }>> => {
    const response = await axiosInstance.post(`${BASE}/${newsId}/view`);
    return response.data;
  },

  /** User-facing: dismiss a blocking news (sets acknowledged_at). */
  acknowledge: async (newsId: number): Promise<ResponseType<null>> => {
    const response = await axiosInstance.post(`${BASE}/${newsId}/acknowledge`);
    return response.data;
  },

  // ── Admin ─────────────────────────────────────────────────────────────────

  list: async (filters?: NewsListFilters): Promise<ResponseType<NewsItem[]>> => {
    const params = new URLSearchParams();
    if (filters?.page !== undefined) params.append("page", String(filters.page));
    if (filters?.limit !== undefined) params.append("limit", String(filters.limit));
    const qs = params.toString();
    const response = await axiosInstance.get(`${BASE}${qs ? `?${qs}` : ""}`);
    return response.data;
  },

  get: async (newsId: number): Promise<ResponseType<NewsItem>> => {
    const response = await axiosInstance.get(`${BASE}/${newsId}`);
    return response.data;
  },

  create: async (payload: NewsItemPayload): Promise<ResponseType<NewsItem>> => {
    const response = await axiosInstance.post(BASE, payload);
    return response.data;
  },

  update: async (
    newsId: number,
    payload: NewsItemPayload
  ): Promise<ResponseType<NewsItem>> => {
    const response = await axiosInstance.put(`${BASE}/${newsId}`, payload);
    return response.data;
  },

  remove: async (newsId: number): Promise<ResponseType<null>> => {
    const response = await axiosInstance.delete(`${BASE}/${newsId}`);
    return response.data;
  },
};
